(function () {
  var translations = {
    'Cookie consent': 'Küpsiste kasutamise nõusolek',
    'We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our':
      'Meie ja meie partnerid, sealhulgas Shopify, kasutame küpsiseid ja muid tehnoloogiaid, et isikupärastada teie kasutuskogemust, näidata teile reklaame ja teha analüüse. Me ei kasuta küpsiseid ega muid tehnoloogiaid nendel eesmärkidel ilma teie nõusolekuta. Lisateavet leiate meie',
    'Privacy Policy': 'privaatsuspoliitikast',
    'Manage preferences': 'Halda eelistusi',
    Accept: 'Nõustu',
    Decline: 'Keeldu',
    'Cookie and privacy preferences': 'Küpsiste ja privaatsuse eelistused',
    'Accept all': 'Nõustu kõigiga',
    'Decline all': 'Keeldu kõigist',
    'Save my choices': 'Salvesta valikud',
    'You control your data': 'Teie otsustate oma andmete üle',
    'Learn more about the cookies we use, and choose which cookies to allow.':
      'Lugege lisateavet meie kasutatavate küpsiste kohta ja valige, milliseid küpsiseid lubada.',
    Required: 'Vajalikud',
    'These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.':
      'Need küpsised on vajalikud veebisaidi nõuetekohaseks toimimiseks, sealhulgas sisselogimiseks ja toodete ostukorvi lisamiseks.',
    Personalization: 'Isikupärastamine',
    'These cookies store details about your actions to personalize your next visit to the website.':
      'Need küpsised salvestavad teavet teie tegevuste kohta, et isikupärastada teie järgmist veebisaidi külastust.',
    Marketing: 'Turundus',
    'These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.':
      'Meie ja meie partnerid, sealhulgas Shopify, kasutame neid küpsiseid turundusteavituste optimeerimiseks ja reklaamide näitamiseks teistel veebisaitidel.',
    Analytics: 'Analüütika',
    'These cookies help us understand how you interact with the site. We use this data to identify areas to improve.':
      'Need küpsised aitavad meil mõista, kuidas te veebisaiti kasutate. Kasutame neid andmeid parandamist vajavate kohtade tuvastamiseks.'
  };

  function translateContainer(container) {
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function (textNode) {
      var source = textNode.nodeValue.trim();
      if (translations[source]) {
        textNode.nodeValue = textNode.nodeValue.replace(source, translations[source]);
      }
    });

    var closeButton = container.querySelector('#shopify-pc__prefs__header-close[aria-label="Close dialog"]');
    if (closeButton) closeButton.setAttribute('aria-label', 'Sulge aken');
  }

  function translateCookieInterface() {
    var banner = document.getElementById('shopify-pc__banner');
    var preferences = document.getElementById('shopify-pc__prefs');

    if (banner) translateContainer(banner);
    if (preferences) translateContainer(preferences);
  }

  var observer = new MutationObserver(translateCookieInterface);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateCookieInterface);
  } else {
    translateCookieInterface();
  }
})();
